/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-controller-access-in-routes, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import moment from 'moment';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import GoalState from '@linc-technologies/linced-common/enums/goal-state';
import { service } from '@ember/service';

export default class HomeRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  model() {
    let startTime = moment()
      .set({ month: 0, day: 1, hour: 0, minute: 0, second: 0 })
      .unix();

    return hash({
      posts: this.store.query('posts/post', {
        visibleOnStudentProfile: 1,
        startTime,
        perPage: 10,
        include: 'reactions,comments',
      }),
      states: this.store.query('goals/state', {
        current: true,
        awarded: GoalState.DEVELOPING,
        include: 'goals',
        isPLP: true,
      }),
      badges: this.store.query('goals/badge', {
        personId: this.get('session.personId'),
      }),
    });
  }

  activate() {
    super.activate(...arguments);
    this.controllerFor('application').set('currentPageId', null);
  }
}
